import autosize from "autosize";

export const initAutosize = () => {
  autosize(document.querySelectorAll("textarea"));
};
